import React, { useContext, useEffect, useRef, useState } from "react";
import "./LinkUnavailable.css";
// import OrderSubtitle from "./Components/OrderSubtitle/OrderSubtitle";
import UniversalCheckoutHeader from "../../UniversalComponents/CheckoutHeader/CheckoutHeader";
import { useNavigate } from "react-router-dom";
import {
  ItemDetailsData,
  SchoolDetails,
} from "../../Utils/DefinitionsInterfaces";
import {
  fetchItemDetails,
  getSchoolByCode,
} from "../../Utils/CheckoutAPIs/CheckoutAPIs";

import { CircularProgress } from "@mui/material";

const LinkUnavailable = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const schoolCode = urlParams.get("scl");

  const [pageLoading, setLoading] = useState(true);

  const [schoolDetails, setSchoolDetails] = useState<SchoolDetails>({
    schoolID: 0,
    schoolName: "",
    linkActive: false,
    city: "",
    state: "",
    individual_registration: false,
    examDate: "",
    isInternational: false,
    version_no: "V1",
    pg: "razorpay",
  });

  const verifyLink = (sclCode: string) => {
    getSchoolByCode(sclCode)
      .then((schoolDetails) => {
        console.log("schoolDetails", schoolDetails);
        if (schoolDetails.linkActive) {
          navigate(`/CheckoutPage/`);
        } else {
          setSchoolDetails(schoolDetails);
        }
      })
      .catch((error) => {
        navigate(`/CheckoutPage/`);
      });
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    if (schoolCode) {
      verifyLink(schoolCode);
    } else {
      navigate(`/CheckoutPage/`);
    }
  }, []);

  // useEffect(() => {
  //   const nfoCheckoutIsApiCallNeeded = sessionStorage.getItem(
  //     "nfoCheckoutIsApiCallNeeded"
  //   );
  //   if (
  //     nfoCheckoutIsApiCallNeeded &&
  //     nfoCheckoutIsApiCallNeeded !== "" &&
  //     nfoCheckoutIsApiCallNeeded === "false"
  //   ) {
  //     console.log("No need of api call");
  //   } else {
  //     console.log("Item Ids from url = ", itemIds);
  //     if (itemIds && itemIds.length > 0) {
  //       //&& !Number.isNaN(cartItemId)) {
  //       let itemsIdsAr: number[] = [];
  //       itemsIdsAr = itemIds.split("-").map(Number);
  //       populateItemDetails(itemsIdsAr);
  //       setCartResetNeeded(false);
  //       sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "false");
  //     }
  //   }
  // }, [stateItemId]);

  // const itemId = localStorage.getItem("itemId");
  // const itemId = sessionStorage.getItem("itemId");

  // const [cartItemId, setCartItemId] = useState(
  //   parseInt(itemId as unknown as string)
  // );

  const navigate = useNavigate();

  // const populateItemDetails = async (itemIds: number[]): Promise<void> => {
  //   let foundItems: ItemDetailsData[] = [];
  //   for (let i = 0; i < itemIds.length; i++) {
  //     const foundItem = await fetchItemDetails(itemIds[i]);
  //     foundItems.push(foundItem[0]);
  //   }
  //   let numOrderItems = foundItems.length;

  //   let presArItems: ItemDetailsData[] = structuredClone(checkoutItems);
  //   console.log(foundItems);
  //   let isStateUpdateNeeded = true;
  //   if (presArItems.sort().join(",") === foundItems.sort().join(",")) {
  //     isStateUpdateNeeded = false;
  //   }

  //   if (isStateUpdateNeeded) setCheckoutItems(foundItems);
  // };

  return pageLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <div className="link-unavailable-page">
      <UniversalCheckoutHeader />
      <div className="link-unavailable-title">
        Registrations{" "}
        {schoolDetails.individual_registration
          ? " "
          : `for ${schoolDetails.schoolName}`}{" "}
        are now closed.
        <br />
        <br />
        For further assistance, please contact{" "}
        {schoolDetails.individual_registration
          ? "support@nationalfinanceolympiad.com"
          : "your school authorities"}
        .
      </div>
      {/* <div className="checkout-footer-wrapper">
        <CheckoutFooter />
      </div> */}
    </div>
  );
};

export default LinkUnavailable;
